// extracted by mini-css-extract-plugin
export default {"blocks":"TitlePage_blocks__+CCPu","block":"TitlePage_block__KroN8","block__content":"TitlePage_block__content__IkEaq","h3":"TitlePage_h3__xehDe"};